<script setup lang="ts">
import Icon from "../../components/icon/icon.vue";
import type { IconSizes } from "../../components/icon/icon.model";
import type { FeedbackType } from "./FeedbackMessage.models";

const props = defineProps<{
  message?: string;
  type?: FeedbackType;
  icon?: string;
  iconSize?: IconSizes | `${IconSizes}`;
}>();
</script>

<template>
  <div
    v-if="props.message"
    role="alert"
    class="feedback-message"
    :class="props.type && `feedback-message--${props.type}`"    
  >
    <Icon :type="props.icon ?? 'info'" :size="props.iconSize ?? 'tiny'" />
    <span>{{ props.message }}</span>
  </div>
</template>
